import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Products from '../Partials/Products/Products';
import ProgressLine from '../Partials/ProgressLine/ProgressLine';
import MovingFooter from '../Partials/MovingFooter/MovingFooter';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import PopUp from '../../../Shared/Popup/PopUp'
import iconNotification from '../Partials/Products/images/icon-120-notification.svg';
import iconAlert from '../Partials/Products/images/icon-alert.svg';
import { gtag4 } from '../../../../utilities/analytics/tracking';

import { goToPage, setPercent, getProducts, setFooterMassage, setSelectedProducts, setErrorPage, setServiceMessageID, createWorkOrder, setMovingWithTechnician, report, selectedProductWithEquipment, bezeqCheckTechnicianType, checkPinTechnician, whatsAppActivityStatus, setWorkOrderDetails, setPinTechnicianDetails, createMemo, setTechnicianType, setTechnicianPage } from '../MovingBlockSlice';

const ProductsPage = (props) => {
  const [displayErrorPopUp, setDisplayErrorPopUp] = useState(false);
  const [isMyTowerCustomer, setIsMyTowerCustomer] = useState(false);
  const [isIdenticalAddress, setIsIdenticalAddress] = useState(false);
  const [displayEnergyBundlePopup, setDisplayEnergyBundlePopup] = useState(false);
  
  useEffect(() => {
    props.setPercent(35);
    props.report({
      actionType: 'Select Services',
      status: 'Ongoing',
      messageText: 'Select Services Page Displayed',
      products: props.products,
      param2: props.fullAddress,
    });
    gtag4({
      event: 'Moving_Step2_ProductsPage',
      title: 'מה נעביר לכתובת החדשה?',
      step: '2',
      action: 'ProductsPage',
      funnel_name: '1 - MovingWithProducts',
    });
  }, []);

  function checkProductBefore(){
      setDisplayEnergyBundlePopup(false)
      const hasEnergyBundle = props.selectedProducts.some(product => product.isEnergyBundle);
      if (hasEnergyBundle) {
          setDisplayEnergyBundlePopup(true);
          setDisplayErrorPopUp(true);
      }else{
        handleBtnClick();
      }
  }

  function handleBtnClick() {
    props.setPinTechnicianDetails(null)
    props.setFooterMassage('')
    props.report({
      actionType: 'Select Services',
      status: 'Ongoing',
      messageText: 'Select Services Page Button Clicked',
      products: props.products,
      param2: props.fullAddress,
      selectedProducts: props.selectedProducts,
      param4: props.selectedEntry?.infrastructure,
    });
    gtag4({
      event: 'Moving_Step2_ContinueButton',
      title: 'מה נעביר לכתובת החדשה?',
      button: "לתיאום מועד הגעה",
      step: '2',
      action: 'ContinueButton',
      funnel_name: '1 - MovingWithProducts',
    });
    if (props.selectedProducts?.length > 0) {
      const hasDebt = props.selectedProducts.some((product) => {
        if (product.hasDebt) {
          return true;
        }
      });
      const hasPaymentMethodIssue = props.selectedProducts.some((product) => {
        if (product.hasPaymentMethodIssue) {
          return true;
        }
      });
      if (hasDebt && hasPaymentMethodIssue) {
        props.report({
          actionType: 'Redirect to Service Message',
          status: 'Service Needed',
          messageText: 'Redirect to Service Message Displayed',
          products: props.products,
          param2: props.fullAddress,
          selectedProducts: props.selectedProducts,
          param4: props.selectedEntry?.infrastructure,
          param9: 'ללקוח יש תשלום חוב ועדכון אמצעי תשלום',
        });
        props.report({
          actionType: 'Finance Message',
          status: 'Service Needed',
          messageText: 'Finance Message Page Displayed',
          products: props.products,
          param2: props.fullAddress,
          selectedProducts: props.selectedProducts,
          param4: props.selectedEntry?.infrastructure,
          param9: 'debt&payment',
        });
        props.setErrorPage('HAS_DEBT_AND_PAYMENT_METHOD_ISSUE');
        return;
      } else if (hasDebt) {
        props.report({
          actionType: 'Redirect to Service Message',
          status: 'Service Needed',
          messageText: 'Redirect to Service Message Displayed',
          products: props.products,
          param2: props.fullAddress,
          selectedProducts: props.selectedProducts,
          param4: props.selectedEntry?.infrastructure,
          param9: 'ללקוח יש תשלום חוב',
        });
        props.report({
          actionType: 'Finance Message',
          status: 'Service Needed',
          messageText: 'Finance Message Page Displayed',
          products: props.products,
          param2: props.fullAddress,
          selectedProducts: props.selectedProducts,
          param4: props.selectedEntry?.infrastructure,
          param9: 'debt',
        });
        props.setErrorPage('HAS_DEBT_ISSUE');
        return;
      } else if (hasPaymentMethodIssue) {
        props.report({
          actionType: 'Redirect to Service Message',
          status: 'Service Needed',
          messageText: 'Redirect to Service Message Displayed',
          products: props.products,
          param2: props.fullAddress,
          selectedProducts: props.selectedProducts,
          param4: props.selectedEntry?.infrastructure,
          param9: 'לקוח צריך לעדכן אמצעי תשלום',
        });
        props.report({
          actionType: 'Finance Message',
          status: 'Service Needed',
          messageText: 'Finance Message Page Displayed',
          products: props.products,
          param2: props.fullAddress,
          selectedProducts: props.selectedProducts,
          param4: props.selectedEntry?.infrastructure,
          param9: 'payment',
        });
        props.setErrorPage('HAS_PAYMENT_METHOD_ISSUE');
        return;
      }

      const isMyTowerCustomer = props.selectedProducts.some(product => product.myTowerCustomer);
      if (isMyTowerCustomer) {
        setIsMyTowerCustomer(true)
        setDisplayErrorPopUp(true);
        return;
      }

      const isIdenticalAddress = props.selectedProducts.some((product) => {
        if (
          product.addressDetails.cityName?.trim() == props.selectedAddress.cityName &&
          product.addressDetails.streetName?.trim() == props.selectedAddress.streetName &&
          product.addressDetails.homeNum?.trim() == props.selectedAddress.home &&
          (product.addressDetails.apartment == null || product.addressDetails.apartment?.trim() == props.selectedAddress.apartment)
        ) {
          return true;
        }
      });

      if (isIdenticalAddress) {
        setIsIdenticalAddress(true);
        setDisplayErrorPopUp(true);
        return;
      }

      const hasEquipmentMoreThenOneProduct = props.selectedProducts.filter((x) => x.moveable == true);
      if (hasEquipmentMoreThenOneProduct?.length > 1) {
        props.setWorkOrderDetails({
          isOpen: true,
          code: 'CB23',
          reason: 'סיבה 12 - נבחר יותר ממוצר אחד שדורש טכנאי',
          stepDescription: 'בחירה בדף מוצרים - בחר יותר ממוצר אחד שדורש טכנאי',
          memoID: "2"
        });
        props.whatsAppActivityStatus({ isErrorPage: false, pageID: 'LAST_DETAILS' });
        return;
      }

      const hasOpenOrder = props.selectedProducts.some((product) => product.hasOpenOrder == true);
      if (hasOpenOrder) {
        props.report({
          actionType: 'Open Order Exists Message',
          status: 'Service Needed',
          messageText: 'Open Order Exists Message Displayed',
          products: props.products,
          param2: props.fullAddress,
          selectedProducts: props.selectedProducts,
          param4: props.selectedEntry?.infrastructure,
        });
        props.setWorkOrderDetails({
          isOpen: true,
          code: 'CB23',
          reason: 'סיבה 8 - קיימת הזמנה אחרת',
          stepDescription: ' בחירה בדף מוצרים -  מוצר שיש לו הזמנה פתוחה ',
          memoID: "2"
        });
        props.whatsAppActivityStatus({ isErrorPage: false, pageID: 'OPEN_ORDER' });
        return;
      }

      const hasTechnicianOrder = props.selectedProducts.some((product) => product.hastechnicianOrder == true);
      const hasDeliveries = props.selectedProducts.some((product) => product.hasDeliveries == true);
      if (hasTechnicianOrder || hasDeliveries) {
        props.setWorkOrderDetails({
          isOpen: true,
          code: 'CB23',
          reason: 'סיבה 13 - קיים טכנאי/שליחות',
          stepDescription: ' בחירה בדף מוצרים - מוצר שקיים לו טכנאי/שליחות ',
          memoID: "2"
        });
        props.whatsAppActivityStatus({ isErrorPage: false, pageID: 'OPEN_ORDER' });
        return;
      }

      const internetProduct = props.selectedProducts.find((x) => x.productType?.toLowerCase() == 'internet');
      const fiberList = ['FB', 'BF', 'BC'];
      const infrastructureNewAddress = props.selectedEntry?.infrastructure;
      if (infrastructureNewAddress == null || infrastructureNewAddress == "NONE" || infrastructureNewAddress == '') {
        props.setWorkOrderDetails({
          isOpen: true,
          code: 'CB23',
          reason: 'סיבה 9 - שגיאה אפליקטיבית',
          stepDescription: 'מסך בחירת מוצרים',
          memoID: "1"
        });
        props.createMemo({ memoID: 'A', description: 'סיבה 9 - שגיאה אפליקטיבית' });
        props.whatsAppActivityStatus({ isErrorPage: false, pageID: 'LAST_DETAILS' });
        return;
      }

      const hasFiberNewAddress = fiberList.includes(infrastructureNewAddress);

      props.setTechnicianType(hasFiberNewAddress ? 'נעיצת טכנאי סיבים' : 'נעיצת טכנאי נחושת');

      if (internetProduct) {
        props.selectedProductWithEquipment('internet');
        if (internetProduct.infrastructure != null) {
          const hasFiberOldAddress = fiberList.includes(internetProduct.infrastructure);
          if (!hasFiberNewAddress) {
            if (hasFiberOldAddress) {// מסיבים לנחושת
              if (props.isPinTechnician) {
                props.checkPinTechnician();
                return;
              }
              else {
                if (props.isJetCustomer) {
                  props.setWorkOrderDetails({
                    isOpen: true,
                    code: 'CB23',
                    reason: 'סיבה 1 - מעבר מסיבים לנחושת',
                    stepDescription: 'מסך בחירת מוצרים',
                    memoID: "2"
                  });
                  props.whatsAppActivityStatus({ isErrorPage: false, pageID: 'LAST_DETAILS' });
                  return;
                }
                else {
                  props.report({
                    actionType: 'Redirect to Service Message',
                    status: 'Service Needed',
                    messageText: 'Redirect to Service Message Displayed',
                    products: props.products,
                    param2: props.fullAddress,
                    selectedProducts: props.selectedProducts,
                    param4: props.selectedEntry?.infrastructure,
                    param9: 'סיבה 5 - מוצר שלא הוסב ל JET',
                    param10: "CB23"
                  });
                  props.createWorkOrder({ code: "CB23", reason: 'סיבה 5 - מוצר שלא הוסב ל JET', stepDescription: "מסך בחירת מוצרים", memoID: "1" });
                  props.createMemo({ memoID: 'A', description: 'סיבה 5 - מוצר שלא הוסב ל JET' });
                  props.setServiceMessageID('OPTICAL_FIBER_FOUNDED');
                  props.goToPage('serviceMessagesPage');
                  return;
                }
              }
            } else {//נחושת לנחושת
              if (props.isJetCustomer) {
                if (props.isPinTechnician) {
                  props.checkPinTechnician();
                  return;
                }
                else {
                  props.setWorkOrderDetails({
                    isOpen: true,
                    code: 'CB23',
                    reason: 'סיבה 4 - מעבר מנחושת לנחושת - לשירות',
                    stepDescription: 'מסך בחירת מוצרים',
                    memoID: "2"
                  });
                  props.createMemo({ memoID: 'A', description: 'סיבה 4 - מעבר מנחושת לנחושת - לשירות' });
                  props.whatsAppActivityStatus({ isErrorPage: false, pageID: 'LAST_DETAILS' });
                  return;
                }
              }
              else {
                props.setWorkOrderDetails({
                  isOpen: true,
                  code: 'CB23',
                  reason: 'סיבה 5 - מוצר שלא הוסב ל JET',
                  stepDescription: 'מסך בחירת מוצרים',
                  memoID: "2"
                });
                props.createMemo({ memoID: 'A', description: 'סיבה 5 - מוצר שלא הוסב ל JET' });
                props.whatsAppActivityStatus({ isErrorPage: false, pageID: 'LAST_DETAILS' });
                return;
              }
            }
          } else {
            if (!hasFiberOldAddress) { //מנחושת לסיבים
              //props.report({ actionType: "Redirect to Service Message ", status: "Service Needed", messageText: "Redirect to Service Message Displayed", products: props.products, param2: props.fullAddress, selectedProducts: props.selectedProducts, param4: props.selectedEntry?.infrastructure, param9: 'סיבה 3 - שדרוג מנחושת לסיבים' })
              if (props.isJetCustomer && internetProduct.infrastructure == "BZ") {//TODO: CHECK IF NEED BZ
                if (props.isDisplayPackages) {
                  if (internetProduct.hasTV || internetProduct.hasMapa) {
                    props.createWorkOrder({ code: "MOV2", reason: "סיבה 3 - שדרוג מנחושת לסיבים", stepDescription: "מסך בחירת מוצרים - לקוח בחר מוצר עם TV או MAPA", memoID: "2" });
                    props.report({
                      actionType: 'Redirect to Service Message',
                      status: 'Service Needed',
                      messageText: 'Redirect to Service Message Displayed',
                      products: props.products,
                      param2: props.fullAddress,
                      selectedProducts: props.selectedProducts,
                      param4: props.selectedEntry?.infrastructure,
                      param9: 'סיבה 3 - שדרוג מנחושת לסיבים',
                      param10: "MOV2"
                    });
                    props.setServiceMessageID('OPTICAL_FIBER_FOUNDED');
                    props.goToPage("serviceMessagesPage");
                    return;
                  }
                  else if (internetProduct.hasMeshEquipment) {
                    props.createWorkOrder({ code: "MOV2", reason: "סיבה 3 - שדרוג מנחושת לסיבים", stepDescription: "מסך בחירת מוצרים - לקוח בחר מוצר עם MESH", memoID: "2" });
                    props.report({
                      actionType: 'Redirect to Service Message',
                      status: 'Service Needed',
                      messageText: 'Redirect to Service Message Displayed',
                      products: props.products,
                      param2: props.fullAddress,
                      selectedProducts: props.selectedProducts,
                      param4: props.selectedEntry?.infrastructure,
                      param9: 'סיבה 3 - שדרוג מנחושת לסיבים',
                      param10: "MOV2"
                    });
                    props.setServiceMessageID('OPTICAL_FIBER_FOUNDED');
                    props.goToPage("serviceMessagesPage");
                    return;
                  }
                  else if (props.isBarakUser) {
                    props.createWorkOrder({ code: "MOV2", reason: "סיבה 3 - שדרוג מנחושת לסיבים", stepDescription: "לקוח ברק", memoID: "2" });
                    props.report({
                      actionType: 'Redirect to Service Message',
                      status: 'Service Needed',
                      messageText: 'Redirect to Service Message Displayed',
                      products: props.products,
                      param2: props.fullAddress,
                      selectedProducts: props.selectedProducts,
                      param4: props.selectedEntry?.infrastructure,
                      param9: 'סיבה 3 - שדרוג מנחושת לסיבים - משתמש ברק',
                      param10: "MOV2"
                    });
                    props.setServiceMessageID('OPTICAL_FIBER_FOUNDED');
                    props.goToPage("serviceMessagesPage");
                    return;
                  }
                  else {
                    //בדיקה אם הכתובת החדשה זה בית פרטי
                    if (((props.selectedEntry?.infrastructure == "BC" || props.selectedEntry?.infrastructure == "FB") && props.selectedEntry?.siteType == "SSB") ||
                      (props.selectedEntry?.infrastructure == "BF" && props.selectedEntry?.gponBuildingType == "A")) {
                      props.createWorkOrder({ code: "MOV2", reason: "סיבה 3 - שדרוג מנחושת לסיבים", stepDescription: "מסך בחירת מוצרים - הכתובת החדשה זה בית פרטי", memoID: "2" });
                      props.report({
                        actionType: 'Redirect to Service Message',
                        status: 'Service Needed',
                        messageText: 'Redirect to Service Message Displayed',
                        products: props.products,
                        param2: props.fullAddress,
                        selectedProducts: props.selectedProducts,
                        param4: props.selectedEntry?.infrastructure,
                        param9: 'סיבה 3 - שדרוג מנחושת לסיבים',
                        param10: "MOV2"
                      });
                      props.setServiceMessageID('OPTICAL_FIBER_FOUNDED');
                      props.goToPage("serviceMessagesPage");
                      return;
                    }
                    else {
                      props.goToPage("packagesPage");
                      return;
                    }
                  }
                }
                else {
                  if (props.isPinTechnician) {
                    props.checkPinTechnician();
                    return;
                  }
                  else {
                    props.createWorkOrder({ code: "MOV2", reason: "סיבה 3 - שדרוג מנחושת לסיבים", stepDescription: "מסך בחירת מוצרים", memoID: "2" });
                    props.report({
                      actionType: 'Redirect to Service Message',
                      status: 'Service Needed',
                      messageText: 'Redirect to Service Message Displayed',
                      products: props.products,
                      param2: props.fullAddress,
                      selectedProducts: props.selectedProducts,
                      param4: props.selectedEntry?.infrastructure,
                      param9: 'סיבה 3 - שדרוג מנחושת לסיבים',
                      param10: "MOV2"
                    });
                    props.setServiceMessageID('OPTICAL_FIBER_FOUNDED');
                    props.goToPage("serviceMessagesPage");
                    return;
                  }
                }
              }
              else {
                props.report({
                  actionType: 'Redirect to Service Message',
                  status: 'Service Needed',
                  messageText: 'Redirect to Service Message Displayed',
                  products: props.products,
                  param2: props.fullAddress,
                  selectedProducts: props.selectedProducts,
                  param4: props.selectedEntry?.infrastructure,
                  param9: 'סיבה 6 - מוצר שלא הוסב ל-JET - אפשרי לשדרג לסיבים למכר',
                  param10: 'MOV2'
                });
                props.createWorkOrder({
                  code: 'MOV2',
                  reason: 'סיבה 6 - מוצר שלא הוסב ל-JET - אפשרי לשדרג לסיבים למכר',
                  stepDescription: 'מסך בחירת מוצרים',
                  memoID: "2"
                });
                props.createMemo({ memoID: 'A', description: 'סיבה 6 - מוצר שלא הוסב ל-JET - אפשרי לשדרג לסיבים למכר' });
                props.setServiceMessageID('OPTICAL_FIBER_FOUNDED');
                props.goToPage('serviceMessagesPage');
                return;
              }
            }
            else {//מסיבים לסיבים
              if (!props.isJetCustomer) {
                props.report({
                  actionType: 'Redirect to Service Message',
                  status: 'Service Needed',
                  messageText: 'Redirect to Service Message Displayed',
                  products: props.products,
                  param2: props.fullAddress,
                  selectedProducts: props.selectedProducts,
                  param4: props.selectedEntry?.infrastructure,
                  param9: 'סיבה 5 - מוצר שלא הוסב לJET אפשרי לשדרג לסיבים - שירות',
                  param10: 'CB23'
                });
                props.createWorkOrder({
                  code: 'CB23',
                  reason: 'סיבה 5 - מוצר שלא הוסב לJET אפשרי לשדרג לסיבים - שירות',
                  stepDescription: 'מסך בחירת מוצרים',
                  memoID: "2"
                });
                props.createMemo({ memoID: 'A', description: 'סיבה 5 - מוצר שלא הוסב לJET אפשרי לשדרג לסיבים - שירות' });
                props.setServiceMessageID('OPTICAL_FIBER_FOUNDED');
                props.goToPage('serviceMessagesPage');
                return;
              }
            }
          }
        }
        else {
          props.setWorkOrderDetails({
            isOpen: true,
            code: 'CB23',
            reason: 'סיבה 9 - שגיאה אפליקטיבית',
            stepDescription: 'מסך בחירת מוצרים',
            memoID: "1"
          });
          props.whatsAppActivityStatus({ isErrorPage: false, pageID: 'LAST_DETAILS' });
          return;
        }
      }

      const isSelectedTvSAProduct = props.selectedProducts.find((x) => x.productType.toUpperCase() == 'TV' && x.equipment == true);
      if (isSelectedTvSAProduct) {
        props.selectedProductWithEquipment("tv");
      }

      const hasEquipment = props.selectedProducts.find((x) => x.moveable == true);
      if (hasEquipment) {
        if (!props.isJetCustomer) {
          if (hasFiberNewAddress) {
            props.report({
              actionType: 'Redirect to Service Message',
              status: 'Service Needed',
              messageText: 'Redirect to Service Message Displayed',
              products: props.products,
              param2: props.fullAddress,
              selectedProducts: props.selectedProducts,
              param4: props.selectedEntry?.infrastructure,
              param9: 'סיבה 6 - מוצר שלא הוסב ל-JET - אפשרי לשדרג לסיבים למכר',
              param10: 'MOV2'
            });
            props.createWorkOrder({
              code: 'MOV2',
              reason: 'סיבה 6 - מוצר שלא הוסב ל-JET - אפשרי לשדרג לסיבים למכר',
              stepDescription: 'מסך בחירת מוצרים',
              memoID: "2"
            });
            props.setServiceMessageID('OPTICAL_FIBER_FOUNDED');
            props.goToPage('serviceMessagesPage');
            return;
          } else {
            props.setWorkOrderDetails({ isOpen: true, code: 'CB23', reason: 'סיבה 5 - מוצר שלא הוסב ל-JET', stepDescription: 'מסך בחירת מוצרים', memoID: "2" });
            props.whatsAppActivityStatus({ isErrorPage: false, pageID: 'LAST_DETAILS' });
            return;
          }
        } else {
          props.setMovingWithTechnician(true);
          props.setTechnicianPage();
        }
      } else {
        props.setMovingWithTechnician(false);
        props.goToPage('summaryPage');
      }
    } else {
      props.setFooterMassage('על מנת להמשיך יש לבחור מוצר')
    }
  }

  function handleClickCheckbox(isChecked, product) {
    props.setSelectedProducts({ isChecked: isChecked, product: product });
    gtag4({
      event: 'Moving_Step2_ChooseProducts',
      title: 'מה נעביר לכתובת החדשה?',
      button: product?.productDescription,
      step: '2',
      action: 'ChooseProducts',
      funnel_name: '1 - MovingWithProducts',
    });
  }

  function handleCloseErrorPopUp(isContinue) {
    setIsMyTowerCustomer(false);
    setIsIdenticalAddress(false);
    setDisplayErrorPopUp(false);
    setDisplayEnergyBundlePopup(false)
    if(displayEnergyBundlePopup && isContinue){
      handleBtnClick();
    }
  }

  const popupContent = (errorMessage) => {
    const icon = displayEnergyBundlePopup ? iconAlert.bg() : iconNotification.bg();
    return (
      <div className='product-error-popup-content'>
        <div className={`product-error-popup-icon`} style={{ backgroundImage: icon }}></div>
        <p className='product-error-popup-title'>{errorMessage}</p>
        { displayEnergyBundlePopup && <p className='product-error-popup-sub-title'>התהליך מתייחס להעברת אינטרנט, TV<br className='mobile-only'/> וטלפון ביתי בלבד <br/> להעברת מונה החשמל יש לחייג ל-{window.Config.energyCallCenter}</p>}
        <BtnSubmit isBusiness={false} text={`הבנתי, תודה`} onclick={() => handleCloseErrorPopUp(true)} />
      </div>
    );
  };

  return (
    <>
      <ProgressLine percent={props.percent} />
      {props.products && (
        <>
          <Products
            products={props.products}
            firstName={props.firstName}
            onClickCheckbox={handleClickCheckbox}
            selectedProducts={props.selectedProducts}
          />
          <PopUp showPopUp={displayErrorPopUp} onClose={() => handleCloseErrorPopUp(false)} className='moving-apartment-products-error-popup'>
          {isIdenticalAddress
            ? popupContent("בחרת מוצר שכבר קיים בכתובת החדשה")
            : isMyTowerCustomer
            ? popupContent(`כדי לבצע את המעבר צריך לדבר איתנו ב-${window.Config.technicalSupportPhone}`)
            : displayEnergyBundlePopup 
            ? popupContent("יש לך חבילה משולבת עם חשמל")
            : null
            }
          </PopUp>
          <MovingFooter onBtnClick={checkProductBefore} btnText={'לתיאום מועד הגעה'} />
        </>
      )}
    </>
  );
};

// export default AddressPage;
const mapStateToProps = (state) => {
  return {
    products: state.movingBlock.movingApartmentData.products,
    isJetCustomer: state.movingBlock.movingApartmentData.isJetCustomer,
    isBarakUser: state.movingBlock.movingApartmentData.isBarakUser,
    selectedProducts: state.movingBlock.movingApartmentData.selectedProducts,
    selectedAddress: state.movingBlock.movingApartmentData.address.selectedAddress,
    selectedEntry: state.movingBlock.movingApartmentData.address.selectedEntry,
    percent: state.movingBlock.movingApartmentData.percent,
    firstName: state.authentication.loginData.userDetails.firstName,
    fullAddress: state.movingBlock.movingApartmentData.address.fullAddress,
    isDisplayPackages: state.movingBlock.movingEpiData.isDisplayFiberOffers.value,
    isPinTechnician: state.movingBlock.movingEpiData.isPinTechnician.value,
  };
};

const mapDispatchToProps = { goToPage, getProducts, setFooterMassage, setPercent, setSelectedProducts, setErrorPage, setServiceMessageID, createWorkOrder, setMovingWithTechnician, report, selectedProductWithEquipment, bezeqCheckTechnicianType, checkPinTechnician, whatsAppActivityStatus, setWorkOrderDetails, setPinTechnicianDetails, createMemo, setTechnicianType, setTechnicianPage };

export default connect(mapStateToProps, mapDispatchToProps)(ProductsPage);
